import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=65974ea9&scoped=true&lang=pug"
import script from "./SendMessageModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageModal.vue?vue&type=style&index=0&id=65974ea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65974ea9",
  null
  
)

export default component.exports